export const DEFAULT_DROPDOWN_TITLE = "Buildings";
